export const env = 'prod'; // updateid

export const REDIRECT_URLS = {
  dev: 'https://local.backlotclub.com/how-to-train-your-dragon',
  stage: 'https://stage.backlot.club/how-to-train-your-dragon',
  uat: 'https://uat.backlot.club/how-to-train-your-dragon',
  prod: 'https://how-to-train-your-dragon.backlot.club/how-to-train-your-dragon',
  alt: 'https://how-to-train-your-dragon.backclub.com/how-to-train-your-dragon'
};
